"use client";

import { useEffect, useState } from "react";
import StatsCard, { StatVariant } from "@/app/(components)/generics/StatsCard/StatsCard";
import { getPatientsStats } from "@/app/actions/patient/action";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { PatientsStats } from "@/app/types/payload/response/PatientsStats";
import { Routes } from "@/app/vars/Routes";

type Props = { lang: string };

export default function PatientsOverview({ lang }: Props) {
  const [stats, setStats] = useState<PatientsStats>({ total: 0, recent: 0 });

  useEffect(() => {
    getPatientsStats().then((data) => {
      if (data) setStats(data);
    });
  }, []);

  return (
    <StatsCard
      title={T(TKey.PATIENTS, lang) as string}
      link={{ href: Routes.PROTECTED.PRO.PATIENTS(lang), label: T(TKey.MANAGE, lang) as string }}
      stats={[
        { value: stats.total, label: T(TKey.OVERVIEW_TOTAL, lang) as string },
        {
          value: stats.recent,
          label: T(TKey.PATIENTS_RECENT, lang) as string,
          variant: StatVariant.ACTIVE,
        },
      ]}
    />
  );
}
